<template>
    <div>
        <b-row>
            <b-col>
                <b-card class="text-center" header-bg-variant="primary" header-text-variant="white" :header="`Status`">
                    <b-card-text class="mt-4">
                        <h2>{{ settlement.status }}</h2>
                    </b-card-text>
                </b-card>
            </b-col>
            <b-col>
                <b-card class="text-center" header-bg-variant="primary" header-text-variant="white" :header="`Approved At`">
                    <b-card-text class="mt-4">
                        <h2>{{ settlement.approvedAt == null ? "(Empty)" : settlement.approvedAt }}</h2>
                    </b-card-text>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-card title="Process Settlement" sub-title="Process settlement to wallet or bank account">
                    <b-card-body>
                        <b-row>
                            <b-col>
                                <b-form-group label="Settlement ID" label-for="settlementId">
                                    <b-form-input id="settlementId" size="lg" v-model="settlement.settlementId" readonly></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label="Amount" label-for="amount">
                                    <b-form-input id="amount" size="lg" v-model="settlement.amount" type="number" readonly></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label="Account Name" label-for="account">
                                    <b-form-input id="accountName" size="lg" v-model="settlement.accountName" readonly></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label="Account Number" label-for="account">
                                    <b-form-input id="accountNumber" size="lg" v-model="settlement.accountNumber" readonly></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label="Bank Name" label-for="bank">
                                    <b-form-input id="bankName" size="lg" v-model="settlement.bankName" readonly></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Settlement Receipt">
                                    <b-form-file v-if="settlement.attachment === null" size="lg" accept="application/pdf, image/png, image/jpeg" v-model="form.attachment" placeholder="Choose a file or drop it here..."></b-form-file>
                                    <a :href="settlement.attachment" v-else target="_blank"><b-button variant="primary" size="sm">View Receipt</b-button></a>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label="Status" label-for="status">
                                    <b-form-select id="status" size="lg" v-model="form.status" :options="['SUCCESS', 'PENDING', 'REJECTED']"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-button variant="primary" size="lg" class="mt-4" block @click="onSubmitBtnHandler">Done</b-button>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>

    </div>
</template>
<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import {
    BBadge,
    BButton,
    BCard,
    BCardBody,
    BCardHeader,
    BCardText,
    BCol,
    BFormCheckbox,
    BFormFile,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BPagination,
    BRow
} from 'bootstrap-vue';
import { getSettlement, updateSettlement } from '../../services/SettlementService';

export default {
    name: "Settlement",
    components: {
        BCard,
        BCardText,
        BBadge,
        BRow,
        BCol,
        BCardBody,
        BButton,
        BFormCheckbox,
        BFormInput,
        BFormSelect,
        BFormGroup,
        BButton,
        BPagination,
        BCardHeader,
        BFormFile
    },
    data() {
        return {
            settlement: {
                id: null,
                settlementId: "",
                amount: "",
                accountName: "",
                accountNumber: "",
                bankName: "",
                attachment: null,
                status: "",
                approvedAt: "",
            },
            form: {
                attachment: null,
                status: "",
            }
        }
    },
    async mounted() {
        this.settlement = await getSettlement(this.$route.params.id);
        this.form.status = this.settlement.status;
    },
    methods: {
        async onSubmitBtnHandler() {
            try {
                const data = {
                    id: this.settlement.id,
                    status: this.form.status,
                    attachment: this.form.attachment
                };
                await updateSettlement(data);
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Save Success!',
                        icon: 'CheckIcon',
                        variant: 'success',
                    },
                });
                this.$router.push('/settlements');
            }
            catch (err) {
                console.log(err);
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Save Failed!',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                        //get res error response body
                        text: err.response.data.message
                    },
                });
            }
        },
    },
}
</script>